export const EVALUATIONS_API_URL='payment-integrity/evaluations/';
export const MEDICAL_RECORDS_API_URL='payment-integrity/medical-records/';
export const QUICK_FILTER_API_URL='standard-search/topfilter';
export const EVALUATION_ADJUSTMENT_API_URL='payment-integrity/evaluations-adjustments/';
export const OVERTURNS_API_URL='payment-integrity/overturn-summary/';
export const AUDIT_REASON_API_URL='payment-integrity/audit-reason-details/';
export const PI_EVALUATION_DETAILS= 'evaluation-details/';
export const PAYMENT_INTEGRITY= 'payment-integrity/';
export const PAYMENT_INTEGRITY_DETAILS_API_URL = 'payment-integrity/medical-records-claim-details/'